function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_centre_align_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M28.4 42.5h226.8v28.3H28.4zM49.6 99.2h184.3v28.3H49.6zM70.9 155.9h141.7v28.3H70.9zM91.4 212.6H192v28.3H91.4z"
})));